import ShippingDeliveryBasicSkuItem from 'components/RwdBasket/Carts/CartLayout/SkuItem/ShippingDeliveryBasicSkuItem/ShippingDeliveryBasicSkuItem';
import withGlobalModals from 'hocs/withGlobalModals';

export default withGlobalModals(ShippingDeliveryBasicSkuItem);
